import React from 'react'
import './BreadCrumb.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Breadcrumb as AntdBreadCrumb } from 'antd';

const BreadCrumb = (props) => {
  const { items, seperatorIcon, onClick } = props;
  // Map over items to attach the onClick handler to each item
  const breadcrumbItems = items.map((item, index) => (
    <AntdBreadCrumb.Item className='breadCrumb-item' key={index} onClick={(e) => onClick(e, item)}>
      {item.icon && <FontAwesomeIcon className='breadCrumb-icon' icon={item.icon} />} {item.label}
    </AntdBreadCrumb.Item>
  ));

  return <AntdBreadCrumb separator={seperatorIcon}>{breadcrumbItems}</AntdBreadCrumb>;
}

export default BreadCrumb